import {
  useCallback
} from "react";

export function useMobileAppLink({
  packageName,
  iosScheme = "tanamemas://",
  androidScheme = "tanamemas://",
  webFallbackUrl = "https://tanamemas.id",
}) {
  const openAppWithMultipleMethods = useCallback(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const openMethods = [
      `${androidScheme}tanamemas`,
      `intent://${androidScheme.replace("://tanamemas", "")}#Intent;package=${packageName};action=android.intent.action.VIEW;category=android.intent.category.DEFAULT;category=android.intent.category.BROWSABLE;end`,
      `market://details?id=${packageName}`,
      webFallbackUrl,
    ];

    const triggerAppOpen = (url) => {
      try {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 5000);
      } catch (error) {
        console.log(error);
      }
    };

    const attemptOpen = () => {
      for (const method of openMethods) {
        console.log("🚀 ~ attemptOpen ~ openMethods:", openMethods);
        console.log("🚀 ~ attemptOpen ~ method:", method);
        try {
          if (userAgent.includes("android")) {
            window.location.href = method;
            triggerAppOpen(method);
          } else if (
            userAgent.includes("iphone") ||
            userAgent.includes("ipad")
          ) {
            window.location.href = iosScheme;
          } else {
            // window.location.href = webFallbackUrl;
          }
          break;
        } catch (error) {
          console.error("Failed to open app:", error);
        }
      }
    };

    attemptOpen();
  }, [packageName, androidScheme, iosScheme, webFallbackUrl]);

  const checkAppInstallation = useCallback(() => {
    return new Promise()((resolve) => {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";

      const checkTimeout = setTimeout(() => {
        iframe.remove();
        resolve(false);
      }, 1500);

      iframe.onload = () => {
        clearTimeout(checkTimeout);
        iframe.remove();
        resolve(false);
      };

      iframe.onerror = () => {
        clearTimeout(checkTimeout);
        iframe.remove();
        resolve(true);
      };

      iframe.src = androidScheme;
      document.body.appendChild(iframe);
    });
  }, [androidScheme]);

  return {
    openApp: openAppWithMultipleMethods,
    checkInstallation: checkAppInstallation,
  };
}